import React, { useState } from 'react';

const QuestionIcon = ({
  fill = 'black',
  width = 24,
  height = 24,
  className = '',
  'data-tooltip-id': tooltipId,
  'data-tooltip-content': tooltipContent,
  'data-tooltip-html': tooltipHtml,
  'data-tooltip-place': tooltipPlace,
  ...props
}) => {
  const [isActive, setIsActive] = useState(false);

  const handleMouseEnter = () => {
    setIsActive(true);
  };

  const handleMouseLeave = () => {
    setIsActive(false);
  };

  const activeClass = isActive ? 'opacity-70' : 'opacity-100';

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} ${activeClass} transition-opacity duration-200 cursor-help`}
      data-tooltip-id={tooltipId}
      data-tooltip-content={tooltipContent}
      data-tooltip-html={tooltipHtml}
      data-tooltip-place={tooltipPlace}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      {...props}
    >
      <mask
        id="mask0_2699_197780"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2699_197780)">
        <path
          d="M12.0192 17.5673C12.3051 17.5673 12.5464 17.4688 12.7433 17.272C12.9401 17.0753 13.0385 16.834 13.0385 16.548C13.0385 16.2622 12.9401 16.0208 12.7433 15.824C12.5464 15.6272 12.3051 15.5288 12.0192 15.5288C11.7334 15.5288 11.4921 15.6272 11.2952 15.824C11.0984 16.0208 11 16.2622 11 16.548C11 16.834 11.0984 17.0753 11.2952 17.272C11.4921 17.4688 11.7334 17.5673 12.0192 17.5673ZM15.2538 9.13275C15.2538 8.30325 14.9721 7.63308 14.4087 7.12225C13.8452 6.61125 13.1116 6.35575 12.2078 6.35575C11.5539 6.35575 10.9603 6.49875 10.427 6.78475C9.89367 7.07058 9.46992 7.4795 9.15575 8.0115C9.06475 8.15633 9.059 8.31467 9.1385 8.4865C9.218 8.65833 9.34875 8.78142 9.53075 8.85575C9.69225 8.91992 9.85892 8.9225 10.0308 8.8635C10.2026 8.8045 10.3443 8.69742 10.4558 8.54225C10.6519 8.25375 10.8907 8.0365 11.172 7.8905C11.4535 7.74433 11.7718 7.67125 12.127 7.67125C12.6385 7.67125 13.0529 7.81225 13.3702 8.09425C13.6876 8.37625 13.8462 8.73775 13.8462 9.17875C13.8462 9.47875 13.7558 9.78267 13.575 10.0905C13.3942 10.3982 13.1102 10.7187 12.723 11.052C12.2897 11.4482 11.9663 11.8129 11.753 12.1463C11.5395 12.4796 11.4058 12.8584 11.352 13.2828C11.325 13.4584 11.3782 13.6196 11.5115 13.7662C11.6448 13.9131 11.8128 13.9865 12.0155 13.9865C12.1975 13.9865 12.3602 13.9266 12.5037 13.8068C12.6474 13.6869 12.7378 13.5257 12.775 13.323C12.825 13.05 12.9198 12.8045 13.0595 12.5865C13.1993 12.3685 13.4359 12.0928 13.7693 11.7595C14.3449 11.184 14.7362 10.7126 14.9432 10.3453C15.1502 9.97792 15.2538 9.57375 15.2538 9.13275ZM5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80258 20.5 5.30775V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.30775ZM5.30775 19H18.6923C18.7693 19 18.8398 18.9679 18.9038 18.9038C18.9679 18.8398 19 18.7693 19 18.6923V5.30775C19 5.23075 18.9679 5.16025 18.9038 5.09625C18.8398 5.03208 18.7693 5 18.6923 5H5.30775C5.23075 5 5.16025 5.03208 5.09625 5.09625C5.03208 5.16025 5 5.23075 5 5.30775V18.6923C5 18.7693 5.03208 18.8398 5.09625 18.9038C5.16025 18.9679 5.23075 19 5.30775 19Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export default QuestionIcon;
